import { atom } from "recoil"

const socialHistoryAtom = atom({
    key: 'socialHistory',
    default: {}
})

export default socialHistoryAtom